import { htmlSafe } from "@ember/template";
import { classNames } from "@ember-decorators/component";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const HomepageStyleSelectorRow = dt7948.c(class HomepageStyleSelectorRow extends SelectKitRowComponent {
  static {
    setComponentTemplate(precompileTemplate("\n    <div class=\"texts\">\n      <span class=\"name\">{{htmlSafe this.label}}</span>\n      {{#if this.item.description}}\n        <span class=\"desc\">{{htmlSafe this.item.description}}</span>\n      {{/if}}\n    </div>\n  ", {
      strictMode: true,
      scope: () => ({
        htmlSafe
      })
    }), this);
  }
}, [classNames("homepage-style-selector-row")]);
export default HomepageStyleSelectorRow;